export default __webpack_public_path__ + "static/media/coinBox.88c4c563.png";